/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Users_AvailableInputs */



/**
* | output |
* | --- |
* | "No users available" |
*
* @param {Team_Manager_No_Users_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_users_available = /** @type {((inputs?: Team_Manager_No_Users_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Users_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun utilisateur disponible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Benutzer verfügbar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun utente disponibile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет доступных пользователей")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay usuarios disponibles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无可用用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用可能なユーザーがいません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई उपयोगकर्ता उपलब्ध नहीं हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum usuário disponível")
	return /** @type {LocalizedString} */ ("No users available")
});